import { useState, useEffect, useRef } from "react";
export default function PrepayQRDifference() {
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) obs.observe(sectionRef.current);
    return () => obs.disconnect();
  }, []);
  const cards = [{
    pillar: "PILLAR 01",
    heading: "Legal Compliance as a Feature",
    body: "No other QR-based prepaid system handles the new 7-day refund law, tracks a-la-carte pricing, or includes built-in indemnification. We handle the complex legal framework of prepaid packages so you can run your spa with absolute peace of mind.",
    claim: "\u201cWe handle the new prepaid law so you don\u2019t have to.\u201d",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
          <circle cx="12" cy="8" r="6"></circle>
        </svg>
  }, {
    pillar: "PILLAR 02",
    heading: "Spa-Optimized QR Reliability",
    body: "Generic QR systems fail 5\u201315% of the time in low-light, lotion-covered, or humid spa environments. PrepayQR fixes that with a hybrid physical+digital system, low-light optimized QR codes, and automatic SMS fallback.",
    claim: "Clients pay instantly, even in the dimmest, most humid treatment rooms.",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect width="14" height="20" x="5" y="2" rx="2" ry="2"></rect>
          <path d="M12 18h.01"></path>
        </svg>
  }, {
    pillar: "PILLAR 03",
    heading: "Zero-Training (But Not Zero-Process)",
    body: "Competitors pretend \u201cno training needed,\u201d then leave your staff making package deduction mistakes. PrepayQR provides a structured, 3-minute micro-training that eliminates manual errors and keeps your books perfectly clean from day one.",
    claim: "Zero operational friction, keeping therapists focused entirely on treatment.",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <polyline points="12 6 12 12 16 14"></polyline>
        </svg>
  }];
  return <section ref={sectionRef} style={{
    backgroundColor: "rgb(255, 255, 255)",
    backgroundPosition: "0% 0%",
    backgroundRepeat: "repeat",
    color: "rgb(42, 45, 43)",
    fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
    paddingTop: "96px",
    paddingBottom: "96px",
    position: "relative",
    overflow: "hidden"
  }}>
      <div className="page-container">
        <div className={`transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="flex flex-col items-center text-center mb-12 md:mb-16">
            <p style={{
            color: "#C8985C",
            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
            fontSize: "11px",
            fontWeight: "600",
            letterSpacing: "0.13em",
            textTransform: "uppercase",
            marginBottom: "12px"
          }}>
              THE PREPAYQR DIFFERENCE
            </p>

            <h2 style={{
            color: "rgb(31, 58, 46)",
            fontFamily: 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
            fontSize: "48px",
            fontWeight: "400",
            lineHeight: "60px",
            textAlign: "center",
            maxWidth: "760px",
            marginBottom: "24px"
          }}>
              PrepayQR isn&rsquo;t just another QR tool &mdash; it&rsquo;s the only prepaid system built specifically for massage spas.
            </h2>

            <p style={{
            color: "rgba(42, 45, 43, 0.7)",
            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
            fontSize: "14px",
            fontWeight: "400",
            lineHeight: "22.75px",
            textAlign: "center",
            maxWidth: "500px"
          }}>
              We now stand on three pillars your competitors simply don&rsquo;t have, protecting your spa legally, working flawlessly in real spa conditions, and making your staff look like pros &mdash; all while increasing prepaid sales automatically.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {cards.map((card, i) => <div key={i} className={`flex flex-col transition-all duration-700`} style={{
            transitionDelay: `${i * 150}ms`,
            backgroundColor: "oklch(96% .01 80)",
            border: "1px solid oklch(69% .04 165 / 0.25)",
            borderRadius: "0px",
            padding: "32px",
            opacity: visible ? 1 : 0,
            transform: visible ? "translateY(0)" : "translateY(16px)"
          }}>
                <div className="flex-1">
                  <div style={{
                width: "48px",
                height: "48px",
                borderRadius: "50%",
                backgroundColor: "rgba(31, 58, 46, 0.08)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#1F3A2E",
                marginBottom: "20px",
                flexShrink: 0
              }}>
                    {card.icon}
                  </div>

                  <p style={{
                color: "#C8985C",
                fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                fontSize: "11px",
                fontWeight: "600",
                letterSpacing: "0.11em",
                textTransform: "uppercase",
                marginBottom: "8px"
              }}>
                    {card.pillar}
                  </p>

                  <h3 style={{
                color: "rgb(31, 58, 46)",
                fontFamily: 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
                fontSize: "24px",
                fontWeight: "600",
                lineHeight: "32px",
                marginBottom: "14px"
              }}>
                    {card.heading}
                  </h3>

                  <p style={{
                color: "rgba(42, 45, 43, 0.75)",
                fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                fontSize: "14px",
                fontWeight: "400",
                lineHeight: "22.75px"
              }}>
                    {card.body}
                  </p>
                </div>

                <div style={{
              marginTop: "28px",
              paddingTop: "20px",
              borderTop: "1px solid oklch(69% .04 165 / 0.25)"
            }}>
                  <p style={{
                color: "#C8985C",
                fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                fontSize: "10px",
                fontWeight: "600",
                letterSpacing: "0.11em",
                textTransform: "uppercase",
                marginBottom: "6px"
              }}>
                    PROVEN VALUE CLAIM
                  </p>

                  <p style={{
                color: "rgb(31, 58, 46)",
                fontFamily: 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "24px",
                fontStyle: "italic"
              }}>
                    {card.claim}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}